export default __webpack_public_path__ + "static/media/_ic_card.3bbbc367.svg";